import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

const options = {
  order: ["localStorage", "querystring", "navigator"],
  lookupQuerystring: "lng",
  lookupLocalStorage: "i18nextLng",
};

// 智能语言回退配置
const fallbackLng = {
  // 简体中文回退链：zh -> zh-CN -> en-US
  'zh': ['zh-CN', 'en-US'],
  // 英文回退链：en -> en-US -> zh-CN
  'en': ['en-US', 'zh-CN'],
  // 标准格式直接回退
  'zh-CN': ['en-US'],
  'en-US': ['zh-CN'],
  // 默认回退链
  'default': ['zh-CN', 'en-US']
};

i18next.use(initReactI18next).use(LanguageDetector).use(Backend).init({
  detection: options,
  fallbackLng: fallbackLng,
  lng: "zh-CN", // 强制设置默认语言为中文
  backend: {
    loadPath: '/locales/{{lng}}/{{ns}}.json',
  },
  debug: process.env.NODE_ENV === 'development',
});
